/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Registry_Cee_ErrorInputs */

const cs_property_registry_cee_error = /** @type {(inputs: Property_Registry_Cee_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dotaz do CEE selhal.`)
};

const en_property_registry_cee_error = /** @type {(inputs: Property_Registry_Cee_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CEE lookup failed.`)
};

/**
* | output |
* | --- |
* | "CEE lookup failed." |
*
* @param {Property_Registry_Cee_ErrorInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_registry_cee_error = /** @type {((inputs?: Property_Registry_Cee_ErrorInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Registry_Cee_ErrorInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_registry_cee_error(inputs)
	return cs_property_registry_cee_error(inputs)
});